import Echo from "laravel-echo"
import Pusher from "pusher-js"

try {
  window.Pusher = Pusher
  // @todo: fix this after investigating the issue
  // @ts-expect-error Pusher.Runtime.createXHR is not typed
  window.Pusher.Runtime.createXHR = function (): XMLHttpRequest {
    const xhr = new XMLHttpRequest()
    xhr.withCredentials = true
    return xhr
  }

  const hostScheme = window.runtimeEnv.VUE_APP_REVERB_SCHEME ?? "https"
  const host = window.runtimeEnv.VUE_APP_REVERB_HOST
  const hostPort = window.runtimeEnv.VUE_APP_REVERB_PORT
  const hostKey = window.runtimeEnv.VUE_APP_REVERB_APP_KEY
  const reverbUrl = `${hostScheme}://${host}:${hostPort}`

  window.Echo = new Echo({
    broadcaster: "reverb",
    authEndpoint: reverbUrl + "/broadcasting/auth",
    userAuthentication: {
      endpoint: reverbUrl + "/broadcasting/user-auth",
      headers: {}
    },
    key: hostKey,
    wsHost: host,
    wsPort: hostPort,
    wssPort: hostPort,
    forceTLS: hostScheme === "https",
    enabledTransports: ["ws", "wss"]
  })
} catch (error) {
  console.warn("Failed to initialize Pusher:", error)
}
